// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  barSlot: "SectionLaborShare__barSlot",
  blurb: "SectionLaborShare__blurb",
  caption: "SectionLaborShare__caption",
  chartTitle: "SectionLaborShare__chartTitle",
  counter: "SectionLaborShare__counter",
  figures: "SectionLaborShare__figures",
  gridSlot: "SectionLaborShare__gridSlot",
  keyRow: "SectionLaborShare__keyRow",
  movedText: "SectionLaborShare__movedText",
  name: "SectionLaborShare__name",
  paper: "SectionLaborShare__paper",
  read: "SectionLaborShare__read",
  readCapital: "SectionLaborShare__readCapital",
  readLabour: "SectionLaborShare__readLabour",
  row: "SectionLaborShare__row",
  rows: "SectionLaborShare__rows",
  section: "SectionLaborShare__section",
  taskKey: "SectionLaborShare__taskKey",
  toWorkers: "SectionLaborShare__toWorkers",
  who: "SectionLaborShare__who",
  you: "SectionLaborShare__you",
};
